var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLctn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#424B53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 20C28.4792 20 24 24.4274 24 29.8803C24 36.1546 30.6667 46.0977 33.1146 49.532C33.2162 49.677 33.3494 49.7949 33.5032 49.8763C33.6571 49.9576 33.8273 50 34 50C34.1727 50 34.3429 49.9576 34.4968 49.8763C34.6506 49.7949 34.7838 49.677 34.8854 49.532C37.3333 46.0991 44 36.1597 44 29.8803C44 24.4274 39.5208 20 34 20Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35C36.2091 35 38 33.2091 38 31C38 28.7909 36.2091 27 34 27C31.7909 27 30 28.7909 30 31C30 33.2091 31.7909 35 34 35Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLctn);
export default __webpack_public_path__ + "static/media/lctn.07a821e4a349a29e78a0581d5ac3feeb.svg";
export { ForwardRef as ReactComponent };